import(/* webpackMode: "eager" */ "/home/paperspace/caldiy-private/releases/20260927-pilot-01/apps/web/app/global-error.tsx");
